/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const userPatientFavorites = sqliteTable('user_patient_favorites', {
  id: text('id').primaryKey().notNull(),
  user_id: text('user_id'),
  patient_id: text('patient_id'),
  created_at: text('created_at'),
});
